var swiperMedia, swiperMediaThumbnails;
swiperMedia = new Swiper('.swiper-media', {
  slidesPerView: 'auto',
  spaceBetween: 12,
  freeMode: true,
  autoHeight: true, 
  mousewheel: {
    forceToAxis: true
  },
  pagination: {
    el: '.swiper-pagination',
  },
  breakpoints: {
    990: {
      slidesPerView: 1,
      spaceBetween: 0,
      freeMode: false,
      mousewheel: false
    }
  }
});
swiperMediaThumbnails = new Swiper('.swiper-media-thumbnails', {
  slidesPerView: 'auto',
  spaceBetween: 6,
  direction: 'vertical',
  mousewheelControl: true,
  freeMode: true,
  autoHeight: true, 
  mousewheel: {
    forceToAxis: true
  }
});
window.swiperMedia = swiperMedia;
window.swiperMediaThumbnails = swiperMediaThumbnails;

$(document).ready(function() {
  
  $('.product__description--collapse').on('click', function() {
    var desc = $('.product__description');
    if (desc.hasClass('product__description--close')) {
      desc.stop().slideDown(500);
      desc.removeClass('product__description--close');
    } else {
      desc.stop().slideUp(500);
      desc.addClass('product__description--close');
    }
    return false;
  });
  
  $(document).on('change', '.upsell-product select', function() {
    var id = $(this).val();
    var upsellProduct = $(this).closest('.upsell-product');
    var variantImage = $('img.variant-' + id, upsellProduct);
    if (variantImage.length > 0) {
      $('img:not(.hidden)', upsellProduct).addClass('hidden');
      variantImage.removeClass('hidden');
    }
    $('[name="upsell"]', upsellProduct).val(id);
  });

  $('.section-add-to-cart-bar .button').on('click', function() {
    var $this = $(this);
    $('.product-form__buttons .product-form__submit').trigger('click');
    setTimeout(function() {
      $('.loading-overlay__spinner', $this).addClass('hidden');
      $('span', $this).removeClass('hidden');
    }, 1000);
    return false;
  });
  
  var addToCartBar = $('.section-add-to-cart-bar');
  if (addToCartBar.length > 0) {
    var addToCartBarLine = $('.add-to-cart-bar-line', addToCartBar);
    addToCartBar.css('height', addToCartBar.height());
    addToCartBarLine.sticky({
      topSpacing: 0
    });
    var headerSticky = $('.header-sticky');
    if (headerSticky.length > 0) {
      addToCartBarLine.on('sticky-start', function() {
        headerSticky.unstick();
      });
      addToCartBarLine.on('sticky-end', function() {
        headerSticky.sticky({ 
          topSpacing: 0 
        });
      });
    }
  }
  $('.section-add-to-cart-bar .links a').on('click', function() {
    var href = $(this).attr('href');
    if (href == '#start') {
      $('html, body').animate({
        scrollTop: 0
      }, 1000);
      return false;
    } else if (href.indexOf('#') != -1 && $(href).length > 0) {
      $('html, body').animate({
        scrollTop: ($(href).offset().top - 72)
      }, 1000);
      return false;
    }
  });
  
  if ($('.product__images-thumbnails').length > 0) {
    swiperMedia.on('slideChange', function() {
      var index = swiperMedia.realIndex;
      swiperMediaThumbnails.slideTo(index);
    });

    $('.product__images-thumbnails .product__images-thumbnails-variant-all a').on('click', function() {
      var thumb = $(this).closest('.swiper-slide');
      var index = parseInt(thumb.data('index'));

      swiperMedia.slideTo(index);
      swiperMediaThumbnails.slideTo(index);

      return false;
    });
    
    $('.color-picker').on('click', function() {
      var image = $(this).data('image');
      if ($('.product__images-slider .swiper-media').length > 0) {
        var thumb = $('.product__images-thumbnails .product__images-thumbnails-variant-all a[data-image="' + image + '"]');
        if (thumb.length > 0 && !thumb.hasClass('active')) {
          var index = parseInt(thumb.data('index')) - 1;
          swiperMedia.slideTo(index);
        }
      }
    });
  }
  
  if ($('.swiper-media-variant').length > 0) {
    $.each($('.swiper-media-variant'), function(k, v) {
      var swiperMediaVariantId = $(v).data('id');
      window['swiperMedia_' + swiperMediaVariantId] = new Swiper('.swiper-media-variant--' + swiperMediaVariantId, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        freeMode: true,
        autoHeight: true, 
        mousewheel: {
          forceToAxis: true
        },
        pagination: {
          el: '.swiper-pagination',
        },
        breakpoints: {
          990: {
            slidesPerView: 1,
            spaceBetween: 0,
            freeMode: false,
            mousewheel: false
          }
        }
      });
      window['swiperMedia_' + swiperMediaVariantId].on('slideChange', function() {
      	var index = window['swiperMedia_' + swiperMediaVariantId].realIndex;
        $('.product__images-thumbnails-variant--' + swiperMediaVariantId + ' a').removeClass('active');
        $('.product__images-thumbnails-variant--' + swiperMediaVariantId + ' a[data-index="' + index + '"]').addClass('active');
      });

      $('.product__images-thumbnails-variant--' + swiperMediaVariantId + ' a').on('click', function() {
        var thumb = $(this);
        if (!thumb.hasClass('active')) {
          var index = parseInt(thumb.data('index'));
          window['swiperMedia_' + swiperMediaVariantId].slideTo(index);
          $('.product__images-thumbnails-variant--' + swiperMediaVariantId + ' a.active').removeClass('active');
          thumb.addClass('active');
        }
        return false;
      });
    });
  }
  
  if ($('.cart--drawer-you-may-also-like-scroller').length > 0) {
    new Swiper('.cart--drawer-you-may-also-like-scroller', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      freeMode: true,
      watchSlidesProgress: true,
      mousewheel: {
        forceToAxis: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
      }
    });
  }
  
});
